import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-medical-case",
  templateUrl: "./med-icon-medical-case.component.html",
})
export class MedIconMedicalCaseComponent extends SvgMixinComponent {}
